module.exports = __webpack_public_path__ + "static/media/KaraIcon.c214d778.png";